type ResolveUserReviewsVisibilityArgs = {
  hasPositiveUserReviews: boolean;
  visitorCanEdit: boolean;
};

type ResolveUserReviewsVisibilityReturnType = {
  isUserReviewsTabOnlyVisibleByOwner: boolean;
  shouldShowUserReviews: boolean;
  shouldShowUserReviewsTab: boolean;
};

export const resolveUserReviewsVisibility = ({
  hasPositiveUserReviews,
  visitorCanEdit,
}: ResolveUserReviewsVisibilityArgs): ResolveUserReviewsVisibilityReturnType => {
  const shouldShowUserReviews = hasPositiveUserReviews;

  const shouldShowUserReviewsTab = shouldShowUserReviews || visitorCanEdit;
  const isUserReviewsTabOnlyVisibleByOwner =
    !shouldShowUserReviews && visitorCanEdit;

  return {
    isUserReviewsTabOnlyVisibleByOwner,
    shouldShowUserReviews,
    shouldShowUserReviewsTab,
  };
};
